export const NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_ACTION = {
  blockPost: 'blockPost',
  blockUser: 'blockUser',
  downloadAllFiles: 'downloadAllFiles',
  pin: 'pin',
  serviceRequest: 'serviceRequest',
}

export const NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_SERVICE_REQUEST_OPTION = {
  addNew: 'addNew',
  attach: 'attach',
}

// `spam` flag the API expects on a post: 1 blocks it, 0 unblocks it.
export const NEWSBOARD_POST_SPAM_BLOCK = 1

export const NEWSBOARD_POST_SPAM_UNBLOCK = 0

export const NEWSBOARD_POST_PROFILE_ACTIONS_WIDGET_QA_NAME = {
  blockPost: 'newsboardPostProfileActionsWidgetBlockPost',
  blockUser: 'newsboardPostProfileActionsWidgetBlockUser',
  downloadAllFiles: 'newsboardPostProfileActionsWidgetDownloadAllFiles',
  pin: 'newsboardPostProfileActionsWidgetPin',
  serviceRequest: 'newsboardPostProfileActionsWidgetServiceRequest',
}
